export default {
  mounted (el) {
    const parentEl = el.parentElement

    const isParentList = parentEl instanceof HTMLUListElement || parentEl instanceof HTMLOListElement || parentEl?.classList.contains('.q-list')

    if (el.classList?.contains('q-expansion-item')) {
      el = el.querySelector('.q-item')
    }

    if (el && !isParentList) {
      el.removeAttribute('role')
    }
  }
}
